
export interface LoginEndpointResult {
  jwt: string
}

export interface LoginEndpointArgs {
  name: string,
  password: string
}

export default function login({post}: any, credents: LoginEndpointArgs): Promise<LoginEndpointResult> {
  return post(`/auth/login`, credents, {retryOn401: false})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/auth/login.tsx